import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import ScreenRotationIcon from "@mui/icons-material/ScreenRotation";

/**
 * Portrait-only overlay: "Please rotate your device" message.
 * Visibility is controlled by CSS (#portrait-only-root show/hide in index.css).
 * This component only renders the content; no visibility logic.
 */
export default function PortraitOnlyOverlay() {
  const theme = useTheme();
  const isShortHeight = useMediaQuery("(max-height: 500px)");

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        bgcolor: theme.palette.mode === "dark" ? "#1e293b" : "#ffffff",
        color: "text.primary",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        px: 3,
        boxSizing: "border-box",
        overflow: "auto",
      }}
    >
      <ScreenRotationIcon
        sx={{
          fontSize: isShortHeight ? 48 : 80,
          mb: isShortHeight ? 1.5 : 3,
          opacity: 0.9,
          color: theme.palette.primary.main,
          flexShrink: 0,
          animation: "pulse 2s ease-in-out infinite",
          "@keyframes pulse": {
            "0%, 100%": { transform: "rotate(0deg) scale(1)", opacity: 0.9 },
            "50%": { transform: "rotate(90deg) scale(1.1)", opacity: 1 },
          },
        }}
      />

      <Typography
        variant="h5"
        fontWeight={700}
        gutterBottom
        sx={{
          fontSize: isShortHeight ? "1.1rem" : undefined,
          maxWidth: "90vw",
        }}
      >
        Please rotate your device
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          mt: 1,
          maxWidth: 300,
          fontSize: isShortHeight ? "0.875rem" : undefined,
        }}
      >
        This app is optimized for portrait mode on mobile devices.
      </Typography>
    </Box>
  );
}
